import type { Invoice,Quote } from '../types';
export type TrashItem=(Quote&{kind:'quote'})|(Invoice&{kind:'invoice'});
export const collectTrash=(quotes:Quote[],invoices:Invoice[]):TrashItem[]=>[
  ...quotes.filter(value=>value.deletedAt&&!value.purgedAt).map(value=>({...value,kind:'quote' as const})),
  ...invoices.filter(value=>value.deletedAt&&!value.purgedAt).map(value=>({...value,kind:'invoice' as const})),
].sort((a,b)=>(b.deletedAt||'').localeCompare(a.deletedAt||''));
export const canRestoreTrash=(record:Pick<Quote,'deletedAt'|'trashExpiresAt'|'purgedAt'>,now=Date.now())=>Boolean(
  record.deletedAt&&!record.purgedAt&&record.trashExpiresAt&&Number.isFinite(Date.parse(record.trashExpiresAt))&&Date.parse(record.trashExpiresAt)>now);
export const trashTimeLeft=(expires:string|null|undefined,now=Date.now())=>{
  if(!expires)return 'รอยืนยันเวลากู้คืน';
  const minutes=Math.max(0,Math.ceil((Date.parse(expires)-now)/60_000));
  if(!Number.isFinite(minutes))return 'รอยืนยันเวลากู้คืน';
  if(!minutes)return 'หมดเวลากู้คืน รอลบถาวร';
  return `กู้ได้อีก ${Math.floor(minutes/60)} ชม. ${minutes%60} นาที`;
};
